// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__5FsDd","spinnerCloum":"spinner_spinnerCloum__zRkg7","loadingMessage":"spinner_loadingMessage__Ym8eX","BeatLoader":"spinner_BeatLoader__bV26M"};